<template>
  <div class="px-4 sm:px-6 lg:px-8">
    <div class="sm:flex sm:items-center">
      <div class="sm:flex-auto">
        <input v-model="query.keyword" type="text" name="first-name" placeholder="关键字筛选" autocomplete="given-name" class="mt-1 mr-4 inline-block border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
      </div>
    </div>
    <div class="mt-4 flex flex-col">
      <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
          <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
            <table class="min-w-full divide-y divide-gray-300">
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">评论内容</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">创建时间</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">状态</th>
                  <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
                    <span class="sr-only">操作</span>
                  </th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200 bg-white">
                <tr v-for="item in tableData" :key="item.id">
                  <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 text-ellipsis overflow-hidden">{{item.Content}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.AddTime}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    <span v-if="item.Status === 0" class="text-green-600">正常</span>
                    <span v-else-if="item.Status === 1">待审核</span>
                    <span class="text-red" v-else>未通过</span>
                  </td>
                  <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                    <a href="javascript:;" class="text-gray-500 hover:text-gray-900 inline-block mr-1" target="_blank">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-4 w-4 text-gray-500">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                      </svg>
                    </a>
                    <!-- <a href="javascript:;" class="text-gray-500 hover:text-gray-900 inline-block mr-1" @click="editAction(item)">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-4 w-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                      </svg>
                    </a> -->
                    <a href="javascript:;" class="text-gray-500 hover:text-gray-900 inline-block mr-1" @click="deleteItem(item)">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                      </svg>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <Pagination :size="query.PageSize" :page="query.PageIndex" :total="total" @change="changePage" />
    <Alert :visible.sync="alertShow" ref="alert" />
    <Notify ref="notify" />
    <Modal :visible.sync="detailDialog" :title="title" :ActionBtnShow="action !== 'view'" width="max-w-7xl" :fullscreen="fullscreen" @submit="submit()">
      <div class="space-y-6 sm:space-y-0 sm:py-0 my-4 mx-2">
        <div class="space-y-1 px-4 sm:grid sm:grid-cols-8 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-2">
          <div>
            <label for="project-description" class="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">内容</label>
          </div>
          <div class="sm:col-span-7 max-h-96 overflow-auto">
            <div id="editormdid" style="z-index: 9999" v-show="action !== 'view'">
              <textarea style="display:none;" v-model="form.Content"></textarea>
            </div>
            <div id="previewmdid" style="z-index: 9999" v-show="action === 'view'">
              <textarea style="display:none;" v-model="form.Content"></textarea>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Pagination from '../components/Pagination.vue'
import Alert from '../components/Alert.vue'
import Notify from '../components/Notification.vue'
import { pageList, remove, edit, add } from '../api/HelpComment'
import { debounce } from 'lodash'
import Modal from '../components/Modal.vue'
export default {
  name: 'CommentList',
  components: { Alert, Notify, Pagination, Modal },
  data () {
    return {
      alertShow: false,
      modalShow: false,
      detailDialog: false,
      query: {
        PageIndex: 1,
        PageSize: 10,
        keyword: '',
        component_type: 4,
        sort: '-id'
      },
      title: '帖子详情',
      content: '',
      tableData: [],
      total: 0,
      action: 'view',
      form: {
        Id: 0,
        Content: ''
      },
      editor: null,
      fullscreen: ''
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getCate (id) {
      const cate = this.cateList.find(i => i.Id === id)
      if (!cate) return '位置分类'
      return cate.Title
    },
    initEditor () {
      this.editor = window.editormd('editormdid', {
        height: 500,
        markdown: this.form.content,
        emoji: true,
        taskList: true,
        tocm: true,
        tex: true,
        flowChart: true,
        sequenceDiagram: true,
        path: '/asset/editor.md/lib/',
        onfullscreen: () => {
          this.fullscreen = 'max-w-full h-screen'
        },
        onfullscreenExit: () => {
          this.fullscreen = ''
        }
      })
      // this.editor.on('onload', () => {
      //   console.log(this.editor.getMarkdown())
      // })
      // editor.setMarkdown(this.form.content)
      // this.editor.on('change', () => {
      //   console.log(this.editor.getMarkdown())
      // })
    },
    preview () {
      window.editormd.markdownToHTML('previewmdid', {
        htmlDecode: "style,script,iframe",
        emoji: true,
        taskList: true,
        tocm: true,
        tex: true,
        flowChart: true,
        sequenceDiagram: true,
      })
    },
    addAction () {
      this.form = {
        Id: 0,
        ParentId: 0,
        CategoryId: 1,
        IsComment: 0,
        Title: '',
        Content: ''
      }
      this.title = '发布帖子'
      this.action = 'add'
      this.detailDialog = true
      this.$nextTick(() => {
        this.initEditor()
      })
    },
    viewAction (row) {
      this.title = '评论详情'
      this.action = 'view'
      this.getItemDetail(row.Id)
    },
    editAction (row) {
      this.title = '评论编辑'
      this.action = 'edit'
      this.form = row
      this.detailDialog = true
      this.$nextTick(() => {
        this.initEditor()
      })
    },
    submit () {
      if (this.action === 'edit') {
        this.updateDetail()
      } else {
        this.postData()
      }
    },
    updateDetail () {
      this.form.Content = this.editor.getMarkdown()
      edit(this.form).then(() => {
        this.notifyShow({ title: '修改成功' })
        this.detailDialog = false
        this.getList()
      })
    },
    postData () {
      this.form.Content = this.editor.getMarkdown()
      add(this.form).then(() => {
        this.notifyShow({ title: '发布成功' })
        this.detailDialog = false
        this.getList()
      })
    },
    changePage (page) {
      this.query.PageIndex = page
    },
    notifyShow (msg = { title: '', desc: '', timeout: 3000 }) {
      this.$refs.notify.show(msg)
    },
    refreshData: debounce(
      function () {
        this.getList()
      },
      800
    ),
    getList () {
      this.loading = true
      pageList(this.query).then(res => {
        const data = res.data.data || {}
        this.tableData = data.list || []
        this.query.PageIndex = data.PageIndex || data.page || 1
        this.query.PageSize = data.PageSize || data.size || this.query.PageSize
        this.total = data.total || data.Total || 0
        // this.$refs.multipleTable.doLayout()
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    },
    deleteItem (item) {
      this.alertShow = true
      new Promise((resolve, reject) => {
        const instance = this.$refs.alert
        instance.confirm = () => {
          this.alertShow = false
          resolve()
        }
        instance.cancel = () => {
          this.alertShow = false
          reject()
        }
      }).then(() => {
        remove(item.Id).then(() => {
          this.notifyShow({ title: '删除成功' })
          this.getList()
        })
      }).catch(() => { console.log('cancel') })
    }
  },
  watch: {
    query: {
      handler: function () {
        this.refreshData()
      },
      deep: true
    }
  }
}
</script>
